import { Controller } from "@hotwired/stimulus"

export default class JudgeOverlayController extends Controller {
  connect(): void {
    requestAnimationFrame(() => {
      this.element.classList.add("judge-overlay--visible")
    })

    setTimeout(() => {
      this.element.classList.remove("judge-overlay--visible")
      this.element.addEventListener("transitionend", () => {
        this.element.remove()
      }, { once: true })
    }, 1500)
  }
}
